
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 26 22","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.126 21.568c9.812 0 15.178-8.129 15.178-15.178 0-.23-.005-.46-.016-.689a10.854 10.854 0 002.661-2.762c-.956.425-1.984.71-3.063.84a5.353 5.353 0 002.346-2.95 10.702 10.702 0 01-3.388 1.294 5.335 5.335 0 00-9.09 4.865A15.146 15.146 0 011.76 1.414a5.322 5.322 0 00-.723 2.681 5.33 5.33 0 002.374 4.44 5.294 5.294 0 01-2.416-.667v.069a5.336 5.336 0 004.28 5.229 5.35 5.35 0 01-2.41.091 5.34 5.34 0 004.983 3.705 10.702 10.702 0 01-6.625 2.284c-.43 0-.855-.025-1.273-.074a15.1 15.1 0 008.177 2.396","fill":"currentColor"}})])
          )
        }
      }
    